import { useQuery } from '@tanstack/react-query';
import { ITeamType } from '@gettactic/api';

export interface TeamMembersAPI {
  client: {
    teams: {
      members: (params: { id: string; query?: string | null; type: ITeamType }) => Promise<any>;
    };
  };
}

export function useTeamMembers(
  teamId: string | null,
  type: ITeamType,
  query: string | null = null,
  api?: TeamMembersAPI
) {
  const {
    data: users,
    error,
    isLoading
  } = useQuery({
    queryKey: ['teams.members', type, teamId, query],

    queryFn: async () => {
      if (!api) {
        throw new Error('API instance must be provided to useTeamMembers hook');
      }
      const res = await api.client.teams.members({
        id: teamId ?? '',
        query,
        type
      });
      return res.result;
    },

    enabled: !!teamId && !!api
  });
  const loading = !users && !error;
  return { users, error, loading, isLoading };
} 